import React, {Component} from 'react';
import styled from '@emotion/styled';
import {colors} from '@atlaskit/theme';
import {grid, borderRadius} from '../constants';
import {Draggable} from 'react-beautiful-dnd';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

import WordList from './WordList';

const Container = styled.div`
  margin: ${grid}px;
  display: flex;
  flex-direction: column;
  flex: 1; /* ADDED to have columns take up horizontal space */
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top-left-radius: ${borderRadius}px;
  border-top-right-radius: ${borderRadius}px;
  /*background-color: ${({isDragging}) => (isDragging ? colors.G50 : colors.N30)};*/
  background-color: ${({isDragging}) => (isDragging ? colors.G50 : 'white')};
  transition: background-color 0.2s ease;

  /* Uncomment if columns are made draggable
  &:hover {
    background-color: ${colors.G50};
  }
  */
`;

const renderHeader = (isEditable, columnIndex, provided, snapshot, sound, handleOnChangeSound, id) => {
  if (columnIndex === 0) return null;
  else if (isEditable) {
    return (
      <Header isDragging={snapshot.isDragging}>
        <Box sx={{minWidth: '90%', padding: '20px'}} isDragging={snapshot.isDragging} {...provided.dragHandleProps}>
          <FormControl fullWidth>
            <InputLabel>Sound</InputLabel>
            <Select value={sound} label="Sound" onChange={(event) => handleOnChangeSound(id, event.target.value)}>
              <MenuItem value="">None</MenuItem>

              <ListSubheader>LONG O DIGRAPHS</ListSubheader>
              <MenuItem value="LONG_O_DIGRAPHS_OA">oa</MenuItem>
              <MenuItem value="LONG_O_DIGRAPHS_OW">ow</MenuItem>
              <MenuItem value="LONG_O_DIGRAPHS_O">o</MenuItem>
              <MenuItem value="LONG_O_DIGRAPHS_O_E">o_e</MenuItem>
              <MenuItem value="LONG_O_DIGRAPHS_OE">oe</MenuItem>

              <ListSubheader>LONG A DIGRAPHS</ListSubheader>
              <MenuItem value="LONG_A_DIGRAPHS_AI">ai</MenuItem>
              <MenuItem value="LONG_A_DIGRAPHS_AY">ay</MenuItem>
              <MenuItem value="LONG_A_DIGRAPHS_EIGH">eigh</MenuItem>
              <MenuItem value="LONG_A_DIGRAPHS_A_E">a_e</MenuItem>

              <ListSubheader>LONG I DIGRAPHS</ListSubheader>
              <MenuItem value="LONG_I_DIGRAPHS_I">i</MenuItem>
              <MenuItem value="LONG_I_DIGRAPHS_IGH">igh</MenuItem>
              <MenuItem value="LONG_I_DIGRAPHS_YE">ye</MenuItem>
              <MenuItem value="LONG_I_DIGRAPHS_Y">y</MenuItem>
              <MenuItem value="LONG_I_DIGRAPHS_I_E">i_e</MenuItem>
              <MenuItem value="LONG_I_DIGRAPHS_IE">ie</MenuItem>

              <ListSubheader>LONG E DIGRAPHS</ListSubheader>
              <MenuItem value="LONG_E_DIGRAPHS_EA">ea</MenuItem>
              <MenuItem value="LONG_E_DIGRAPHS_IE">ie</MenuItem>
              <MenuItem value="LONG_E_DIGRAPHS_EE">ee</MenuItem>
              <MenuItem value="LONG_E_DIGRAPHS_E_E">e_e</MenuItem>
              <MenuItem value="LONG_E_DIGRAPHS_E">e</MenuItem>

              <ListSubheader>LONG U DIGRAPHS</ListSubheader>
              <MenuItem value="LONG_U_DIGRAPHS_EW">ew</MenuItem>
              <MenuItem value="LONG_U_DIGRAPHS_OO">oo</MenuItem>
              <MenuItem value="LONG_U_DIGRAPHS_UE">ue</MenuItem>
              <MenuItem value="LONG_U_DIGRAPHS_U_E">u_e</MenuItem>
              <MenuItem value="LONG_U_DIGRAPHS_UI">ui</MenuItem>
              <MenuItem value="LONG_U_DIGRAPHS_OU">ou</MenuItem>

              <ListSubheader>R-CONTROLLED VOWELS</ListSubheader>
              <MenuItem value="R_CONTROLLED_VOWELS_AR">ar</MenuItem>
              <MenuItem value="R_CONTROLLED_VOWELS_ER">er</MenuItem>
              <MenuItem value="R_CONTROLLED_VOWELS_IR">ir</MenuItem>
              <MenuItem value="R_CONTROLLED_VOWELS_OR">or</MenuItem>
              <MenuItem value="R_CONTROLLED_VOWELS_UR">ur</MenuItem>

              <ListSubheader>DIPTHONGS</ListSubheader>
              <MenuItem value="DIPTHONGS_OI">oi</MenuItem>
              <MenuItem value="DIPTHONGS_OY">oy</MenuItem>
              <MenuItem value="DIPTHONGS_OU">ou</MenuItem>
              <MenuItem value="DIPTHONGS_OW">ow</MenuItem>
              <MenuItem value="DIPTHONGS_AU">au</MenuItem>
              <MenuItem value="DIPTHONGS_AW">aw</MenuItem>

              {/* {Object.entries(LETTER_COMBINATION_GROUP_SUBTITLES).map(([key, value]) => (
                <MenuItem key={key} value={key}>
                  {value}
                </MenuItem>
              ))} */}
            </Select>
          </FormControl>
        </Box>
      </Header>
    );
  } else {
    const soundLabel = sound
      .replace('LONG_O_DIGRAPHS_', '')
      .replace('LONG_A_DIGRAPHS_', '')
      .replace('LONG_I_DIGRAPHS_', '')
      .replace('LONG_E_DIGRAPHS_', '')
      .replace('LONG_U_DIGRAPHS_', '')
      .replace('R_CONTROLLED_VOWELS_', '')
      .replace('DIPTHONGS_', '')
      .toLowerCase();
    return (
      <Header isDragging={snapshot.isDragging}>
        <ListItem sx={{boxShadow: 1}}>
          <ListItemText
            // primary={LETTER_COMBINATION_GROUP_SUBTITLES[sound]}
            primary={soundLabel}
            primaryTypographyProps={{variant: 'h5', className: 'fnt-bold clr-dark-blue'}}
          />
        </ListItem>
      </Header>
    );
  }
};

export default class Column extends Component {
  render() {
    const {column, index, handleOnChangeSound, isScrollable, handleClickDeleteWord, isEditable} = this.props;
    const {id, words} = column;
    const sound = column.sound || '';

    return (
      <Draggable draggableId={id} index={index} isDragDisabled={true}>
        {(provided, snapshot) => (
          <Container ref={provided.innerRef} {...provided.draggableProps}>
            {/* <Header isDragging={snapshot.isDragging}> */}
            {renderHeader(isEditable, index, provided, snapshot, sound, handleOnChangeSound, id)}
            {/* </Header> */}

            <WordList
              listId={id}
              listType="QUOTE"
              style={{
                // backgroundColor: snapshot.isDragging ? colors.G50 : null,
                backgroundColor: snapshot.isDragging ? colors.G50 : 'white',
              }}
              words={words}
              internalScroll={isScrollable}
              handleClickDeleteWord={(wordIndex) => handleClickDeleteWord(column, wordIndex)}
              isEditable={isEditable}
            />
          </Container>
        )}
      </Draggable>
    );
  }
}
